export type RememberedOperationsControl = {
  label: string;
  action: string | null;
  capturedAt: number;
};

const CONTROL_TTL_MS = 2 * 60_000;
let lastControl: RememberedOperationsControl | null = null;
let installed = false;

function cleanLabel(value: string, max = 120): string {
  return value.replace(/https?:\/\/\S+/gi, "[redacted]").replace(/[\r\n\t]+/g, " ").trim().slice(0, max);
}

function labelFromTarget(target: EventTarget | null): string | null {
  if (!(target instanceof Element)) return null;
  const control = target.closest("button, a, [role='button'], [data-cleo-control]");
  if (!(control instanceof HTMLElement)) return null;
  if (control.closest("input, textarea, [contenteditable='true']")) return null;
  const explicit = control.getAttribute("data-cleo-control") || control.getAttribute("aria-label");
  const text = explicit || control.textContent;
  const cleaned = cleanLabel(text ?? "");
  return cleaned || null;
}

export function rememberOperationsControlClick(input: { label: string; action?: string | null }): void {
  const label = cleanLabel(input.label);
  if (!label) return;
  lastControl = {
    label,
    action: input.action ? cleanLabel(input.action, 128) : null,
    capturedAt: Date.now(),
  };
}

export function readRecentOperationsControl(now = Date.now()): RememberedOperationsControl | null {
  if (!lastControl) return null;
  if (now - lastControl.capturedAt > CONTROL_TTL_MS) return null;
  return lastControl;
}

export function resetOperationsControlContextForTests(): void {
  lastControl = null;
  installed = false;
}

export function installOperationsControlCapture(): void {
  if (installed || typeof document === "undefined") return;
  installed = true;
  document.addEventListener("click", (event) => {
    const label = labelFromTarget(event.target);
    if (!label) return;
    rememberOperationsControlClick({ label });
  }, true);
}
